import {
  inboundShipmentIdFormat,
  locationIdFormat,
  purchaseOrderIdFormat,
  supplierIdFormat,
} from "@redotech/redo-ids/ids";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const InboundShipmentStatus = {
  PENDING: "PENDING",
  IN_TRANSIT: "IN_TRANSIT",
  PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
  RECEIVED: "RECEIVED",
} as const;
export type InboundShipmentStatus =
  (typeof InboundShipmentStatus)[keyof typeof InboundShipmentStatus];

const ShipmentListItemSchema_ = z.object({
  id: inboundShipmentIdFormat.schema,
  shipmentId: z.string().nullish(),
  purchaseOrders: z.array(
    z.object({ id: purchaseOrderIdFormat.schema, poNumber: z.string() }),
  ),
  status: createEnum([
    InboundShipmentStatus.PENDING,
    InboundShipmentStatus.IN_TRANSIT,
    InboundShipmentStatus.PARTIALLY_RECEIVED,
    InboundShipmentStatus.RECEIVED,
  ]),
  skuCount: z.number().int(),
  skus: z.array(z.string()),
  itemCount: z.number().int(),
  receivedCount: z.number().int(),
  estimatedArrivalDate: zExt.plainDate().nullish(),
  actualArrivalDate: zExt.plainDate().nullish(),
  totalCost: z.number(),
  currency: z.string(),
  location: z
    .object({ id: locationIdFormat.schema, name: z.string() })
    .nullish(),
  supplier: z
    .object({ id: supplierIdFormat.schema, name: z.string() })
    .nullish(),
  createdAt: zExt.instant(),
});

export const ShipmentListItemSchema: z.ZodType<ShipmentListItem> =
  ShipmentListItemSchema_;
export interface ShipmentListItem extends z.infer<
  typeof ShipmentListItemSchema_
> {}

export const getShipments = {
  name: "getShipments" as const,
  input: z.object({}),
  output: z.object({ shipments: z.array(ShipmentListItemSchema) }),
};
